import { render, staticRenderFns } from "./PersonalDataSettings.vue?vue&type=template&id=05795ef1&scoped=true"
import script from "./PersonalDataSettings.vue?vue&type=script&lang=js"
export * from "./PersonalDataSettings.vue?vue&type=script&lang=js"
import style0 from "./PersonalDataSettings.vue?vue&type=style&index=0&id=05795ef1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05795ef1",
  null
  
)

export default component.exports